export const connectionsI18n = [
    {
        key: 'connections.form.header',
        de: 'Verbindungen',
        en: 'Connections',
        it: 'Composti',
        fr: 'Correspondances',
        nl: 'Aansluitingen',
    },
    {
        key: 'connections.form.from',
        de: 'Abfahrt aus...',
        en: 'Departure from...',
        it: 'Partenza da...',
        fr: 'Départ de...',
        nl: 'Vertrek vanaf...',
    },
    {
        key: 'connections.form.outward',
        de: 'Hinfahrt',
        en: 'Outward',
        it: 'Andata',
        fr: 'Destination',
        nl: 'Heenreis',
    },
    {
        key: 'connections.form.return',
        de: 'Rückfahrt',
        en: 'Return',
        it: 'Ritorno',
        fr: 'Retour',
        nl: 'Terugreis',
    },
    {
        key: 'connections.form.date',
        de: 'Start der Reise',
        en: 'Start of the journey',
        it: 'Data del viaggio',
        fr: 'Début du voyage',
        nl: 'Start van de reis',
    },
    {
        key: 'connections.form.search',
        de: 'Suchen',
        en: 'Search',
        it: 'Search',
        fr: 'Chercher',
        nl: 'Zoeken',
    },
    {
        key: 'connections.cartransport.possible',
        de: 'Fahrzeugtransport möglich',
        en: 'Vehicle transport possible',
        it: 'Trasporto dei veicoli possibile',
        fr: 'Transport de véhicule possible',
        nl: 'Voertuigtransport mogelijk',
    },
    {
        key: 'connections.cartransport.notpossible',
        de: 'Fahrzeugtransport nicht möglich',
        en: 'Vehicle transport not possible',
        it: 'Trasporto dei veicoli non possibile',
        fr: 'Transport de véhicule impossible',
        nl: 'Voertuigtransport niet mogelijk',
    },
    {
        key: 'connections.none',
        de: 'Keine Verbindungen gefunden. Bitte versuchen Sie ein anderes Abfahrtsland.',
        en: 'No connections found. Please try another departure country.',
        it: 'Nessuna connessione trovata. Si prega di provare un altro paese di partenza.',
        fr: 'Aucune correspondance trouvée. Veuillez essayer une autre région de départ.',
        nl: 'Geen aansluitingen gevonden. Probeer het nog een keer met een ander land van vertrek.',
    },
    {
        key: "connections.results.single",
        de: "1 Verbindung gefunden",
        en: "1 connection found",
        it: "1 connessione trovata",
        fr: "1 correspondance trouvée",
        nl: "1 aansluiting gevonden",
    },
    {
        key: "connections.results.multiple",
        de: "{0} Verbindungen gefunden",
        en: "{0} connections found",
        it: "{0} Composti trovati",
        fr: "{0} Correspondances trouvées",
        nl: "{0} Aansluitingen gevonden",
    },
    {
        key: "connections.oebb",
        de: "Verbindungen vom ÖBB Nightjet",
        en: "Connections of ÖBB Nightjet",
        it: "Collegamenti delle ÖBB Nightjet",
        fr: "Connexions de ÖBB Nightjet",
        nl: "Aansluitingen van ÖBB Nightjet",
    },
    {
        key: "connections.dani",
        de: "Verbindungen vom Nightjet der neuen Generation",
        en: "Connections of Nightjet of the new generation",
        it: "Collegamenti delle Nightjet di nuova generazione",
        fr: "Connexions de Nightjet nouvelle génération",
        nl: "Aansluitingen van Nightjet van de nieuwe generatie",
    },
    {
        key: "connections.partner",
        de: "Verbindungen von Partnerbahnen",
        en: "Connections of Nightjet partners",
        it: "Collegamenti delle ferrovie partner",
        fr: "Connexions de partenaires",
        nl: "Aansluitingen van partner-spoorwegmaatschappijen",
    },
];
//# sourceMappingURL=connections-i18n.js.map
